import React from 'react';
import { ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ConsolidatedNavContextProvider } from 'src/providers/ConsolidatedNavContextProvider';
import { ConsolidatedSideNavInner } from './ConsolidatedSideNavInner';

interface ConsolidatedSideNavProps {
  toolbarItems: Array<ToolbarItem>;
  updateSelectedNavItem?: (toolbarItemId: string, linkId: string) => void;
  landingAppName?: string;
  updateLandingAppName?: (landingAppName: string) => void;
}

export const ConsolidatedSideNav: React.VFC<ConsolidatedSideNavProps> = ({
  toolbarItems,
  updateSelectedNavItem,
  landingAppName,
  updateLandingAppName,
}) => (
  <ConsolidatedNavContextProvider
    initToolbarItems={toolbarItems}
    landingAppName={landingAppName}
    updateLandingAppName={updateLandingAppName}
    updateSelectedNavItem={updateSelectedNavItem}
  >
    <ConsolidatedSideNavInner />
  </ConsolidatedNavContextProvider>
);
